import { RefObject, useRef } from "react";

export const useRefreshRef = <TParams = unknown>(
	refresh?: (params?: Partial<TParams>) => Promise<unknown> | void,
): RefreshableElementRef<TParams> => {
	const ref = useRef<RefreshableElement<TParams> | undefined>(undefined);
	const ret = {
		ref: ref,
		refresh: async (params?: Partial<TParams>) => {
			if (ref.current !== undefined) await ref.current.refresh(params);
		},
	};
	if (refresh !== undefined) {
		setRefreshRefValue(ret, refresh);
	}
	return ret;
};

export interface RefreshableElementProps {
	refreshRef?: RefreshableElementRef;
}

export type RefreshableElementRef<TParams = unknown> = {
	ref: RefObject<RefreshableElement<TParams> | undefined>;
	refresh: (params?: Partial<TParams>) => Promise<unknown>;
};

export interface RefreshableElement<TParams = unknown> {
	refresh: (params?: Partial<TParams>) => Promise<unknown>;
}

export const setRefreshRefValue = <TParams = unknown>(
	refreshRef: RefreshableElementRef<TParams> | undefined,
	refresh: (params?: Partial<TParams>) => Promise<unknown> | void,
) => {
	if (refreshRef !== undefined)
		refreshRef.ref.current = {
			refresh: async (params?: Partial<TParams>) => await refresh(params),
		};
};
